import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia';
import axiosPlugin from '@/plugins/axios';
import utilsAll from '@/plugins/utils-all'

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js'; // Collapse 토글에 필요 (Popper 포함)
import 'bootstrap-icons/font/bootstrap-icons.css'

import 'pretendard/dist/web/variable/pretendardvariable.css';

import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'   

import VueCookies from "vue3-cookies"

import { useKakao } from 'vue3-kakao-maps/@utils';

const KAKAO_KEY = process.env.VUE_APP_KAKAO_APP_KEY

useKakao(KAKAO_KEY);

const app = createApp(App)

app
    .component('Datepicker', Datepicker);

app
    .use(utilsAll)
    .use(router)
    .use(createPinia())
    .use(axiosPlugin)

    .use(VueCookies,{
        expireTimes: "7d",
        secure: true,
    })

  // canonical 태그 갱신 함수
const updateCanonical = (href) => {
  const url = new URL(href, window.location.origin)
  // 추적 파라미터 제거 (선택)
  const stripParams = ['utm_source','utm_medium','utm_campaign','utm_term','utm_content','gclid','fbclid']
  stripParams.forEach(k => url.searchParams.delete(k))

  let link = document.querySelector("link[rel='canonical']")
  if (!link) {
    link = document.createElement('link')
    link.setAttribute('rel', 'canonical')
    document.head.appendChild(link)
  }
  link.setAttribute('href', url.toString())

}

router.isReady().then(() => {
  
    // 최초 진입 시 한 번
    updateCanonical(`https://pawinhand.kr${router.currentRoute.value.fullPath}`)

    // 라우팅마다 갱신
    router.afterEach((to) => {
      updateCanonical(`https://pawinhand.kr${to.fullPath}`)
    })

    app.mount('#app')

})
